import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setDrawer, setDrawerAlert } from 'slices/drawer'
import { BillsButton, PaymentError } from 'components'
import { DRAWER_KEY } from 'app-constants'
import { formatCurrency, formatDueDate } from 'utils'
import { usePayment } from 'hooks'
import './style.scss'

export function PaymentOptions({ id, value, dueDate, codeBar, urlFile, isPaid }) {
  const { isLoading, hasError, getOptions, success, errorMessage } = usePayment(id, urlFile, isPaid)
  const dispatch = useDispatch()

  useEffect(() => {
    if (success) {
      dispatch(setDrawer(DRAWER_KEY.NONE))
    }
  }, [success, dispatch])

  useEffect(() => {
    if (errorMessage) {
      dispatch(setDrawerAlert({ severity: 'error', title: errorMessage }))
    }
  }, [errorMessage, dispatch])

  function renderButtons() {
    if (isLoading) return <div className='loading' />
    const options = getOptions()
    return options.map(({ icon, label, onClick, copyMessage, copyToClipboard }) => (
      <BillsButton
        key={label}
        codeBar={codeBar}
        copyMessage={copyMessage}
        copyToClipboard={copyToClipboard}
        icon={icon}
        label={label}
        onClick={onClick}
      />
    ))
  }

  return (
    <div className='payment-options-container'>
      <h2 className='title'>Pagar Fatura</h2>
      <div className='info-container'>
        <div className='value-container'>
          <h3 className='title'>Valor da Fatura</h3>
          <div className='value'>{formatCurrency(value)}</div>
        </div>
        <p className='info'>
          {formatDueDate(dueDate)}
          <br />
          <span className='dot' aria-hidden='true' />
          Aguardando pagamento
        </p>
      </div>
      <div className='action-container'>{renderButtons()}</div>
      <PaymentError hasError={hasError} />
    </div>
  )
}
